import React, { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import DraggableElement from './DraggableElement';
import { ElementType } from '../../types/element.types';

interface ElementCategoryProps {
  name: string;
  elements: Array<{
    type: ElementType;
    label: string;
    icon: string;
  }>;
}

/**
 * Element Category Component
 * Collapsible category of elements in the library
 */
const ElementCategory: React.FC<ElementCategoryProps> = ({ name, elements }) => {
  const [isExpanded, setIsExpanded] = useState(true);

  return (
    <div className="element-category">
      {/* Category Header */}
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full flex items-center justify-between p-2 hover:bg-gray-100 rounded transition-colors"
      >
        <span className="text-sm font-semibold text-gray-700">{name}</span>
        {isExpanded ? (
          <ChevronDown size={16} className="text-gray-500" />
        ) : (
          <ChevronRight size={16} className="text-gray-500" />
        )}
      </button>

      {/* Category Elements */}
      {isExpanded && (
        <div className="mt-2 space-y-2">
          {elements.map((element) => (
            <DraggableElement
              key={element.type}
              type={element.type}
              label={element.label}
              icon={element.icon}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default ElementCategory;

